import hydrateWithHOCs from 'views/containers/browser/utils/hydrateWithHOCs'

import VolumePricingModalContainer from '.'

export default ({
  container,
  i18n,
  volumeBasedPrices,
  volumeDiscount,
  volumeQuantity,
  volumeDiscountActivated,
}) => {
  hydrateWithHOCs({
    container,
    i18n,
  })(
    <VolumePricingModalContainer
      volumeBasedPrices={volumeBasedPrices}
      volumeDiscount={volumeDiscount}
      volumeQuantity={volumeQuantity}
      volumeDiscountActivated={volumeDiscountActivated}
    />
  )
}
